<template>
	<div v-if="devBypassEnabled && bannerVisible" class="dev-banner" role="status">
		DEV AUTH BYPASS — fake user, fake API. Disable by removing
		<code>VITE_DEV_BYPASS_AUTH</code>
		from
		<code>.env.development.local</code>
		.
		<button type="button" class="dev-banner__close" aria-label="Hide dev banner" @click="bannerVisible = false">
			×
		</button>
	</div>
	<router-view />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { devBypassEnabled } from '@/auth/devBypass'

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()

const bannerVisible = ref(true)

// Mid-session session loss: when the HTTP layer or the Auth0 SDK reports that the session
// is gone, the auth store flips to 'unauthenticated'. Bounce the user to /signin and remember
// where they were so we can return after login.
watch(
	() => auth.status,
	(next, prev) => {
		if (prev === 'authenticated' && next === 'unauthenticated' && route.path !== '/signin') {
			router.replace({ path: '/signin', query: { next: route.fullPath } })
		}
	},
)
</script>

<style scoped lang="scss">
.dev-banner {
	background: #fde68a;
	color: #78350f;
	padding: 6px 12px;
	font-size: 0.6rem;
	text-align: center;
	border-bottom: 1px solid #f59e0b;
	position: absolute;
	z-index: 1;
	opacity: 0.5;

	code {
		background: rgba(0, 0, 0, 0.08);
		padding: 0 4px;
		border-radius: 3px;
	}

	&__close {
		background: transparent;
		border: none;
		color: inherit;
		cursor: pointer;
		padding: 0 4px;
		margin-left: 4px;
		font-size: 0.9rem;
		line-height: 1;
		font-family: inherit;

		&:hover {
			opacity: 0.7;
		}
	}
}
</style>
